import { render, staticRenderFns } from "./FormAlignmentMGHRWCFromModal.vue?vue&type=template&id=02a21bda&scoped=true&"
import script from "./FormAlignmentMGHRWCFromModal.vue?vue&type=script&lang=ts&"
export * from "./FormAlignmentMGHRWCFromModal.vue?vue&type=script&lang=ts&"
import style0 from "./FormAlignmentMGHRWC.style.scss?vue&type=style&index=0&id=02a21bda&prod&lang=scss&scoped=true&"
import style1 from "./FormAlignmentMGHRWCFromModal.vue?vue&type=style&index=1&id=02a21bda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a21bda",
  null
  
)

export default component.exports